import { ConversationMessageContentType } from 'src/@types/conversation';
import { AssetsRequests } from 'src/requests/assets';
import { create } from 'zustand';
import type { ConversationMediaState } from './interfaces';

export const conversationMediaStateFactory = () =>
  create<ConversationMediaState>((set, get) => ({
    mediaContent: {},
    setMediaContent: (mediaId, messageMediaContent) => {
      const { mediaContent } = get();
      set({
        mediaContent: {
          ...mediaContent,
          [mediaId]: messageMediaContent,
        },
      });
    },
    getMediaContent: async (message, mediaRefKey = 'mediaRef') => {
      const mediaRef = message[mediaRefKey];
      if (!mediaRef) return;
      const { setMediaContent } = get();
      const file: Blob = await AssetsRequests.getPrivateFile(
        mediaRef,
        ({ loaded }) => {
          if (!mediaRef) return;
          const percentageLoaded = (loaded / (message.fileSize || 0)) * 100;
          setMediaContent(mediaRef, { percentageLoaded });
        },
      );
      const mediaContent = URL.createObjectURL(file);
      setMediaContent(mediaRef, { mediaContent, percentageLoaded: 0 });
      return new File([file], message.fileName || '', {
        type: message.contentType,
      });
    },
    checkInitialMediaContentDownload: (message, type = 'mediaRef') => {
      if (!message[type]) return;
      const { mediaContent, getMediaContent } = get();
      if (
        (message.contentType === ConversationMessageContentType.VIDEO ||
          message.contentType === ConversationMessageContentType.AUDIO ||
          message.contentType === ConversationMessageContentType.IMAGE) &&
        !mediaContent[message[type]]
      ) {
        getMediaContent(message, type);
      }
    },
  }));
